import 'alpinejs';
import 'lightbox2';
import 'lity';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/attrchange/ls.attrchange';

// Components
import './components/header';
import './components/hero-carousel';
import './components/slider';
import './components/image-gallery';
import './components/tour';
import './components/my-blackheath';
import './components/latest-posts';
import './components/load-more';
import './components/testimonials-slider';
import video from './components/video';

document.addEventListener('DOMContentLoaded', () => {
	video.init();
});
